<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div class="dialog-title" v-t="'message.action_create_user'">
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body-small">
                    <el-form class="dialog-form-item" label-width="170px" >
                        <!--- ユーザーID --->
                        <el-form-item ref="userName" prop="userName">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_userId'"></span> <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_userId')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="userName" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.userName.value" autocomplete="off"
                                 @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                 clearable @clear="InputCheckAll()"/>
                        </el-form-item>
                        <!--- ユーザー表示名 --->
                        <el-form-item ref="displayName" prop="displayName">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_userDisplayName'"></span> <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_user_display_name')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="displayName" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.displayName.value" autocomplete="off"
                                 @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                 clearable @clear="InputCheckAll()"/>
                        </el-form-item>
                        <!--- パスワード --->
                        <el-form-item ref="password" prop="password">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_password'"></span> <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_password')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                                <span style="position:relative">
                                    <button class="input-pass-check" type="button" @click="handleChangePasswordCheck()">{{ passwordShowHideButton }}</button>
                                </span>
                            </div>
                            <el-input id="password" size="large" :type="inputTypeOfPassword" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.password.value" autocomplete="new-password"
                                 @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                 @clear="InputCheckAll()"/>
                        </el-form-item>
                        <!--- 部署名 --->
                        <el-form-item ref="organization" prop="organization">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_organization'"/>
                                <el-tooltip effect="dark" placement="top-start" >
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_searching_user_item')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="organization" size="large" type="text" v-model="inputForm.organization.value"
                                 @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                 clearable @clear="InputCheckAll()"/>
                        </el-form-item>
                        <!--- 役職名 --->
                        <el-form-item ref="title" prop="title">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_job_title'"/>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_searching_user_item')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="title" size="large" type="text" v-model="inputForm.title.value"
                                 @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                 clearable @clear="InputCheckAll()"/>
                        </el-form-item>
                        <!--- 電話番号 --->
                        <el-form-item ref="phoneNumber" prop="phoneNumber">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_tenant_phone'"/>
                                <el-tooltip effect="dark" placement="top-start" >
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_user_phoneNumber')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="phoneNumber" size="large" type="text" v-model="inputForm.phoneNumber.value"
                                 @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                 clearable @clear="InputCheckAll()"/>
                        </el-form-item>
                        <!--- ################################## --->
                        <!--- email address                      --->
                        <!--- ################################## --->
                        <el-form-item ref="emailAddress" prop="emailAddress">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_tenant_email'"/>
                                <el-tooltip effect="dark" placement="top-start" >
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_user_emailAddress')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="emailAddress" size="large" type="text" v-model="inputForm.emailAddress.value"
                                 @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                 clearable @clear="InputCheckAll()"/>
                        </el-form-item>
                        <!--- かんたんログイン --->
                        <el-form-item style="text-align:right">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_option_easyLogin'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-t="'message.hint_easy_login'"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-switch v-model="userOptions.easyLogin" active-color="#5171cb" @change="handleOptionChange('easyLogin')"></el-switch>
                        </el-form-item>
                        <div v-if="showOptionSetting">
                        <!--- かんたんログインQR表示 --->
                        <el-form-item style="text-align:right" label-width="280px">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_option_easyLogin_QR'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-t="'message.hint_easy_login_qr'"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-switch v-model="userOptions.showGroupUrl" active-color="#5171cb" @change="handleOptionChange('showGroupUrl')"></el-switch>
                        </el-form-item>
                        <div v-if="showOptionSetting">
                        <!--- 割込み通話権限 --->
                        <el-form-item style="text-align:right">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_option_interrupt_permission'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-t="'message.hint_option_interrupt_permission'"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-switch v-model="userOptions.interrupt" active-color="#5171cb" @change="handleOptionChange('interrupt')"></el-switch>
                        </el-form-item>
                        <div v-if="showOptionSetting">
                        <!--- マップ通話オプション --->
                        <el-form-item style="text-align:right">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_option_map_talk'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-t="'message.hint_option_map_talk'"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-switch v-model="userOptions.mapTalk" active-color="#5171cb" @change="handleOptionChange('mapTalk')"></el-switch>
                        </el-form-item>
                        <div v-if="showOptionSetting">
                        <!--- hide all options when online purchase / speech-to-text license not exist ---->
                        <!--- 有償オプション説明 --->
                        <p class="beside-line" v-t="'message.item_option'"></p>
                        <p class="option-description">
                            <span v-if="appData.basicContract.planType == 0" v-t="'message.hint_option_description1'"/>
                            <span v-else v-t="'message.hint_option_description1_plan'"/>
                            <br>
                            <span v-t="'message.hint_option_description2'"/>
                        </p>
                        <!--- 音声テキスト化オプション --->
                        <el-form-item v-if="isVisibleUserOption('speechToText')" style="text-align:right">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_option_speechToText'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-t="'message.hint_option_speechToText'"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-switch v-model="userOptions.speechToText" active-color="#5171cb" @change="handleOptionChange('speechToText')"></el-switch>
                        </el-form-item>
                        <!--- 翻訳オプション --->
                        <el-form-item v-if="isVisibleUserOption('translation')" style="text-align:right">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_option_translation'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_option_translation')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-switch v-model="userOptions.translation" active-color="#5171cb" @change="handleOptionChange('translation')"></el-switch>
                        </el-form-item>
                        <!--- 動態管理オプション --->
                        <el-form-item v-if="isVisibleUserOption('tracking')" style="text-align:right">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_option_location_tracking'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-t="'message.hint_option_location_tracking'"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-switch v-model="userOptions.tracking" active-color="#5171cb" @change="handleOptionChange('tracking')"></el-switch>
                        </el-form-item>
                        <!---ライブキャストオプション --->
                        <el-form-item v-if="isVisibleUserOption('video')" style="text-align:right">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_option_video'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-t="'message.hint_option_video'"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-switch v-model="userOptions.video" active-color="#5171cb" @change="handleOptionChange('video')"></el-switch>
                        </el-form-item>
                        </div>
                    </el-form>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" @click="addUser" :disabled="this.$data.disableButton" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import characterCheck from './charactercheck.js';
import commonUtil from './commonutil.js';
import commonValidate from './common-validate.js';
import constants from './constants.js';

export default {
    data() {
        return {
            inputForm: {
                userName:       { validationRule: "userId",           valid: false,   value: null,   isComposing: false },
                displayName:    { validationRule: "reqDisplayName",   valid: false,   value: null,   isComposing: false },
                password:       { validationRule: "password",         valid: false,   value: null,   isComposing: false },
                organization:   { validationRule: "displayName",      valid: true,    value: null,   isComposing: false },
                title:          { validationRule: "displayName",      valid: true,    value: null,   isComposing: false },
                phoneNumber:    { validationRule: "phoneNumber",      valid: true,    value: null,   isComposing: false },
                emailAddress:   { validationRule: "userEmailAddress", valid: true,    value: null,   isComposing: false },
            },
            userOptions: {
                speechToText:   false,
                translation:    false,
                tracking:       false,
                mapTalk:        false,
                video:          false,
                easyLogin:      false,
                interrupt:      false,
                showGroupUrl:   false,
            },
            inputTypeOfPassword: "password",
            passwordShowHideButton: "SHOW",
            disableButton: true,
        };
    },
    methods: {
        addUser: function() {
            this.$emit('add', {
                        name: this.$data.inputForm.userName.value,
                        displayName: this.$data.inputForm.displayName.value,
                        password: this.$data.inputForm.password.value,
                        organization: this.$data.inputForm.organization.value,
                        title: this.$data.inputForm.title.value,
                        phoneNumber: this.$data.inputForm.phoneNumber.value,
                        emailAddress: this.$data.inputForm.emailAddress.value,
                        userOptions: this.userOptions
            });
        },
        handleOptionChange(changedOption) {
            commonUtil.checkChangedUserOptionCondition(this, changedOption, this.appData, this.userOptions);
            this.setButtonStatus();
        },
        handleChangePasswordCheck() {
            if (this.inputTypeOfPassword == "password") {
                this.inputTypeOfPassword = "text";
            } else {
                this.inputTypeOfPassword = "password";
            }
        },
        setButtonStatus: function() {
            if (commonValidate.checkFormValidation(this.inputForm)) {
                this.disableButton = false;
            } else {
                this.disableButton = true;
            }
        },
        inputCheck(eventTargetId) {
            if (this.inputForm[eventTargetId].isComposing) {
                // inputting with IME
                return;
            }
            let validateResult;
            if (eventTargetId == "phoneNumber") {
                validateResult = commonValidate.validateItem(this.$i18n, this.inputForm[eventTargetId].validationRule, this.inputForm[eventTargetId].value, this.appData.countryCodeAlpha3);
            } else {
                validateResult = commonValidate.validateItem(this.$i18n, this.inputForm[eventTargetId].validationRule, this.inputForm[eventTargetId].value);
            }
            if (validateResult.valid) {
                this.inputForm[eventTargetId].valid = true;
                this.$refs[eventTargetId].clearValidate();
            } else {
                this.inputForm[eventTargetId].valid = false;
                this.$refs[eventTargetId].validateState = "error";
                this.$refs[eventTargetId].validateMessage = validateResult.message;
            }
            this.setButtonStatus();
        },
        InputCheckAll() {
            for (let targetId in this.inputForm) {
                this.inputCheck(targetId);
            }
        },
        compositionStart(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = true;
        },
        compositionEnd(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = false;
            this.inputCheck(eventTargetId)
        },
        isVisibleUserOption(optionName) {
            if (this.appData.basicContract.planType == constants.LICENSE_PLAN_SEPARATE) {
                return commonUtil.isVisibleUserOption(this.appData.onlinePurchase, optionName);
            } else {
                return true;
            }
        }
    },
    created: function() {
    },
    watch: {
        inputTypeOfPassword(newVal) {
            if (newVal == "password") {
                this.passwordShowHideButton = "SHOW";
            } else {
                this.passwordShowHideButton = "HIDE";
            }
        }
    },
    computed: {
        showOptionSetting: function() {
            if (this.appData.onlinePurchase) {
                if (this.appData.basicContract.planType != constants.LICENSE_PLAN_SEPARATE) {
                    return true;
                } else {
                    if ((this.appData.enableSpeechTextOption) || (this.appData.enableSpeechTextTrial)) {
                        return true;
                    } else {
                        return false;
                    }
                }
            } else {
                return true;
            }
        }
    },
    mounted: function() {
        // tabIndex of tooltip was always set to 0 (Should set -1 to skip focus)
        for (let element of document.getElementsByClassName('icon-help')) {
            element.setAttribute("tabIndex", "-1");
        }
    },
    props: ['appData']
}
</script scoped>

<style scoped>
button.input-pass-check {
    border-style: none;
    background-color: #fff;
    cursor: pointer;
    outline: none;
    position: absolute;
    height: 20px;
    width: 44px;
    left: 270px;
    top: 2px;
    font-size: 10px;
    z-index: 10;
    color: #848991;
}
</style>
